import { SubscriptionPaymentMethod } from "features/payment-methods/components";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { ComponentProps } from "react";

interface PaymentMethodModalProps
  extends Omit<
    ComponentProps<typeof SubscriptionPaymentMethod>,
    "onBack" | "onSuccess"
  > {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export default function SubscriptionPaymentMethodModal({
  subscriptionId,
  isOpen,
  setIsOpen,
  initialPaymentSource,
}: PaymentMethodModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <SubscriptionPaymentMethod
          subscriptionId={subscriptionId}
          initialPaymentSource={initialPaymentSource}
          onBack={() => setIsOpen(false)}
          onSuccess={() => setIsOpen(false)}
        />
      </Content>
    </Component>
  );
}
